import React, { forwardRef, useState } from 'react';
import { Grid, Typography, Box } from '@mui/material';

import { buildSubmittedUserLabel } from 'utilities/user';
import { replaceBaseUrl } from 'components/AnnotaionItem/utilities';

import { SLIDE_VIEWER_URL } from 'constants/urls';

import { useAnnotationItemStyles } from 'components/AnnotaionItem/styles';

export const AnnotationItem = forwardRef(({ comments, data, slide }, ref) => {
  const { classes } = useAnnotationItemStyles();
  const [isError, setIsError] = useState(false);

  const redirectToSlideViewer = () => {
    const slideViewerURL = data?.target?.source?.endsWith('undefined')
      ? SLIDE_VIEWER_URL.replace(':slideUUID', slide.uuid)
      : replaceBaseUrl(data.target.source);
    window.open(slideViewerURL, '_blank');
  };

  const handleError = () => {
    setIsError(true);
  };

  return (
    <Grid
      ref={ref}
      container
      className={`${classes.slideDataContainer} ${classes.slideInfoRow}`}
      onClick={redirectToSlideViewer}
    >
      <Grid item width="100%" marginBottom="0.5rem">
        <Typography className={classes.annotationCaption}>
          {slide.name} / <b>{slide.order.name}</b>
        </Typography>
      </Grid>
      <Grid item xs={3} xl={2} display="flex" justifyContent="center">
        <Box>
          {isError ? (
            <Typography className={classes.placeholderText}>
              No Thumbnail Available
            </Typography>
          ) : (
            <img
              className={classes.image}
              src={slide.medium_thumbnail_url}
              alt="thumbnail"
              onError={handleError}
            />
          )}
        </Box>
      </Grid>
      <Grid item xs={9} xl={10}>
        <Grid item xs={12}>
          {comments.map((comment) => (
            <Box key={comment.uuid} className={classes.commentContainer}>
              <Typography className={classes.submittedUser}>
                {buildSubmittedUserLabel(comment.user, comment.created)}
              </Typography>
              <Typography className={classes.commentText}>
                {comment.value}
              </Typography>
            </Box>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
});

AnnotationItem.displayName = 'AnnotationItem';
